// import Swiper from 'swiper';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
const HomeSwiper = {
    init() {
        // JavaScript to be fired on the home page
        this._jCareSlider = $('.care__slider');
        this._jCareContainer = $('.jsCareContainer');
        this._jCare = $('.care');

        this._addEvents();
        this.finalize();
    },
    _addEvents() {

    },
    finalize() {
        this.initSwipers();
        this._jCareSlider.css('margin-left', 0);
    },
    initSwipers() {
        new Swiper($('.jsSwiper')[0], {
            autoplay: {
                delay: 1000000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            slidesPerView: 1,
            loop: false,
            speed: 600,
            freeMode: true,
            observer: true,
            observeParents: true,
            // mousewheel: {
            //     releaseOnEdges: true,
            // },
            breakpoints: {
                // when window width is >= 320px
                768: {
                    slidesPerView: 2,
                },
                930: {
                    slidesPerView: 3,
                    //slidesPerView: 'auto',
                },
                1024: {
                    // slidesPerView: 3,
                    slidesPerView: 'auto',
                },

            },
            modules: [Navigation, Pagination,Autoplay],
        });

    },
};

export default HomeSwiper;


// WEBPACK FOOTER //
// ./scripts/modules/home.swiper.js